import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
// import Carousel from "react-multi-carousel";
import {
  HomeUpdatedArrowIcon,
  HomeUpdatedNextIcon,
  HomeUpdatedPrevIcon,
  HomeCoreServiceMobile,
  HomeCoreServiceWeb,
  HomeCoreServiceCustom,
  HomeCoreServiceGame,
  HomeCoreServiceDevops,
  HomeCoreServiceITStaff,
  HomeCoreServiceCloud,
} from "../../../../app-constants";

import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../../app-constants";
import sOne from "../../../images/locationgcc/bh/android-bahrain.webp";
import sTwo from "../../../images/locationgcc/bh/ios-bahrain.webp";
import sThree from "../../../images/locationgcc/bh/game-bahrain.webp";
import sFour from "../../../images/locationgcc/bh/flutter-bahrain.webp";
import sFive from "../../../images/locationgcc/bh/reactnative-bahrain.webp";
import sSix from "../../../images/locationgcc/bh/custom-bahrain.webp";

import { Link } from "gatsby";

function Services({ handleShow }) {
  const allCss = `
    .serv-item .serv-inner::before {
      content: '';
    }
    .home-serv-one .serv-inner::before {
      background-image: url(${sOne});
    }
    .home-serv-two .serv-inner::before {
      background-image: url(${sTwo});
    }
    .home-serv-three .serv-inner::before {
      background-image: url(${sThree});
    }
    .home-serv-four .serv-inner::before {
      background-image: url(${sFour});
    }
    .home-serv-five .serv-inner::before {
      background-image: url(${sFive});
    }
    .home-serv-six .serv-inner::before {
      background-image: url(${sSix});
    }
      `;

  return (
    <>
      <style>{allCss}</style>
      <section className="tekrevol__services bahrain-services p-100">
        <Container>
          <Row>
            <Col
              xs={12}
              md={10}
              lg={9}
              xl={9}
              xxl={8}
              className="m-auto text-center"
            >
              <h2>
                Our <span>Mobile App Development</span> Services in Bahrain
              </h2>
              <p>
                As a leading app development company in Bahrain, we specialize
                in crafting cutting-edge apps that streamline your business
                operations and drive exceptional outcomes. We consistently stay
                ahead of our competitors by focusing on innovative technologies
                and user-centric designs. Below are the specialized mobile app
                development services we offer:
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
              <div className="serv-tab position-relative">
                <div className="serv-item home-serv-one">
                  <div className="serv-inner">
                    <div className="serv-inner-icon">{AndroidIcon}</div>
                    <Link
                      to="/android-app-development"
                      aria-label="Android App Development"
                      className="title_wrap"
                    >
                      <h5>Android App Development</h5>{" "}
                    </Link>
                    <p>
                      Harnessing the power of Kotlin, Android Studio, and the
                      latest Jetpack libraries, our developers in Bahrain create
                      Android apps with a seamless user experience. We emphasize
                      modular architecture and high-performance APIs, ensuring
                      your app operates flawlessly under high loads. Each app is
                      tailored to surpass client expectations and maintain
                      optimal performance in Bahrain’s fast-paced digital
                      environment.
                    </p>
                    {/* <Link
                          to="/mobile-app-development"
                          aria-label="Mobile App Development"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link> */}
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
              <div className="serv-tab position-relative">
                <div className="serv-item home-serv-two">
                  <div className="serv-inner">
                    <div className="serv-inner-icon">{IphoneIcon}</div>
                    <Link
                      to="/iphone-app-development"
                      className="title_wrap"
                      aria-label="Web Development"
                    >
                      <h5>iPhone App Development</h5>
                    </Link>
                    <p>
                      Our iOS development team delivers comprehensive solutions,
                      from concept to App Store deployment. Leveraging Swift and
                      the latest iOS SDKs, we focus on creating apps that not
                      only meet Apple’s rigorous standards but also resonate
                      with Bahrain’s tech-savvy audience. Integration with
                      iCloud and advanced CoreData ensures your app is secure
                      and scalable for future updates.
                    </p>
                    {/* <Link
                          to="/web-development"
                          aria-label="Web Development"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link> */}
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
              <div className="serv-tab position-relative">
                <div className="serv-item home-serv-three">
                  <div className="serv-inner">
                    <div className="serv-inner-icon">{GameIcon}</div>
                    <Link
                      to="/game-development"
                      className="title_wrap"
                      aria-label="Software Development"
                    >
                      <h5>Game App Development</h5>
                    </Link>
                    <p>
                      Our Bahrain-based team specializes in creating visually
                      stunning and technically superior game apps. Using Unity
                      and Unreal Engine, we develop games that push the
                      boundaries of what’s possible on mobile. Our focus on
                      real-time rendering and optimized asset management ensures
                      your game app delivers a captivating experience across all
                      devices.
                    </p>
                    {/* <a href="">{HomeUpdatedArrowIcon}</a> */}
                    {/* <Link
                          to="/custom-software-development"
                          aria-label="Software Development"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link> */}
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
              <div className="serv-tab position-relative">
                <div className="serv-item home-serv-four">
                  <div className="serv-inner">
                    <div className="serv-inner-icon">{FlutterIcon}</div>
                    <Link
                      to="/flutter-app-development"
                      aria-label="Game Development"
                      className="title_wrap"
                    >
                      <h5>Flutter App Development</h5>
                    </Link>
                    <p>
                      Utilizing Flutter’s comprehensive widget library, our team
                      crafts cross-platform apps that feel native on both
                      Android and iOS. We prioritize rapid development cycles
                      and continuous integration practices, allowing your app to
                      launch faster and perform flawlessly across Bahrain’s
                      diverse device ecosystem. The result is a cost-effective
                      solution that doesn't compromise on quality or user
                      experience.
                    </p>
                    {/* <Link
                          to="/game-development"
                          aria-label="Game Development"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link> */}
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
              <div className="serv-tab position-relative">
                <div className="serv-item home-serv-five">
                  <div className="serv-inner">
                    <div className="serv-inner-icon">{ReactIcon}</div>
                    <Link
                      to="/react-native-app-development"
                      aria-label="IT Staff Augmentation"
                      className="title_wrap"
                    >
                      <h5>React Native App Development</h5>
                    </Link>
                    <p>
                      Our React Native development services in Bahrain focus on
                      delivering high-performance mobile apps with near-native
                      experience. By leveraging React Native’s reusable
                      components and native modules, we ensure fast loading
                      times and a smooth user interface. Our apps are designed
                      to function flawlessly even under heavy data usage, making
                      them ideal for Bahrain’s growing mobile market.
                    </p>
                    {/* <Link
                          to="/solution/it-staff-augmentation"
                          aria-label="IT Staff Augmentation"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link> */}
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
              <div className="serv-tab position-relative">
                <div className="serv-item home-serv-six">
                  <div className="serv-inner">
                    <div className="serv-inner-icon">{HealthcareIcon}</div>
                    <Link
                      to="/custom-software-development"
                      aria-label="Cloud Consulting"
                      className="title_wrap"
                    >
                      <h5>Custom App Development</h5>
                    </Link>
                    <p>
                      Our custom app development services are fully tailored to
                      your business objectives. Using microservices architecture
                      and advanced security protocols, we build apps that are
                      not only scalable but also secure. Our Bahrain team
                      collaborates closely with you throughout the development
                      process, ensuring the final product aligns perfectly with
                      your strategic goals and user expectations.
                    </p>
                    {/* <Link
                          to="/cloud-computing-consultants"
                          aria-label="Cloud Consulting"
                        >
                          {HomeUpdatedArrowIcon}
                        </Link> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-3 mt-md-4">
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="m-auto text-center"
            >
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                View More Services
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Services;
